export const exceptions = state => state.exceptions
